// Saved settings win over the defaults; entries without a default (e.g.
// per-table ones) are kept as they are.
export const mergeQrCodeSettings = (defaults, saved) => {
  const savedNames = new Set(saved.map((item) => item.name));
  return [...defaults.filter((item) => !savedNames.has(item.name)), ...saved];
};

// Changes only the disabled flags of one entry and keeps its other fields.
export const updateQrCodeSettingByName = (settings, name, disabled, disabledDate) => {
  const existing = settings.find((item) => item.name === name);
  return [
    ...settings.filter((item) => item.name !== name),
    { ...existing, name, disabled, disabledDate },
  ];
};
